<template>
    <transition name="ds-header-slide-over__transition" appear>
        <div
            class="ds-header-slide-over"
            :class="[
                { 'ds-header-slide-over--with-shadow' : withShadow },
                { 'ds-header-slide-over--width-full' : widthFull }
            ]"
            data-j-content>
            <slot></slot>
        </div>
    </transition>
</template>

<script>
/**
 * Header navigation vertical slide over component
 * it's meant to be used with the header navigation vertical only
 */
export default {
    name: 'DsHeaderNavigationVerticalSlideOver',
    props: {
        withShadow: { type: Boolean, default: false },
        widthFull: { type: Boolean, default: false }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../foundation/tokens/variables';
@import '../../../foundation/mixins/mixins';

.ds-header-slide-over {
    background-color: $color-white;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: $z-index-1;

    &--with-shadow {
        box-shadow: -$spacing-12 $spacing-24 $spacing-24 0 #{$color-black}1A;
    }

    @include screen('medium') {
        width: $spacing-12*35;

        &--width-full {
            width: 100%;
        }
    }

    &__transition-enter-active,
    &__transition-leave-active {
        transition: transform 0.25s ease;
    }

    &__transition-enter,
    &__transition-leave-to {
        transform: translateX(100%);
        transition: transform 0.15s ease-in 0s;
    }
}
</style>
